import { render } from "./FooterMs.vue?vue&type=template&id=93716598"
import script from "./FooterMs.vue?vue&type=script&lang=js"
export * from "./FooterMs.vue?vue&type=script&lang=js"

import "./FooterMs.vue?vue&type=style&index=0&id=93716598&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__